var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6285 13.9428L12.6285 11.9429C13.6571 10.8 14.2857 9.25714 14.2857 7.59999C14.2857 3.99999 11.3714 1.02856 7.71424 1.02856C4.11424 1.02856 1.19995 3.94285 1.19995 7.59999C1.19995 11.2 4.11424 14.1714 7.77138 14.1714C9.25709 14.1714 10.6857 13.6571 11.7714 12.8L13.7714 14.8C13.8857 14.9143 14.0571 14.9714 14.2285 14.9714C14.4 14.9714 14.5142 14.9143 14.6857 14.8C14.8571 14.5714 14.8571 14.1714 14.6285 13.9428ZM7.71424 12.9143C4.74281 12.9143 2.39995 10.5143 2.39995 7.59999C2.39995 4.62856 4.79995 2.28571 7.71424 2.28571C10.6857 2.28571 13.0285 4.68571 13.0285 7.59999C13.0857 10.5143 10.6857 12.9143 7.71424 12.9143Z",
    fill: "#1B1B1F",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.f72496dd7cc6fca144022220888b33b7.svg";
export { ForwardRef as ReactComponent };